import ScopeDescription from './ScopeDescription';

export default ScopeDescription;
